import { ChatParticipant } from '@my-ipractice/types';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ChatParticipantDetails } from './chat-participant-details';
import { useTranslation } from 'react-i18next';

type Props = {
  participants: ChatParticipant[];
  open: boolean;
  setOpen: (newValue: boolean) => void;
};

export const ChatParticipantsDialog = ({ participants, open, setOpen }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(newValue) => setOpen(newValue)}>
      <DialogContent className="lg:min-w-[750px]" onInteractOutside={() => setOpen(false)}>
        <DialogHeader>
          <DialogTitle>{t('chat_page.chatParticipantsTitle')}</DialogTitle>
          <DialogDescription>{t('chat_page.chatParticipantsDescription')}</DialogDescription>
        </DialogHeader>
        <div className="text-sm grid grid-cols-2 gap-1">
          {participants.map((x) => (
            <ChatParticipantDetails key={x.name + x.role} participant={x} />
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            {t('chat_page.chatParticipantsClose')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
